import { Button, CloseButton, Divider, Flex, LoadingOverlay } from "@mantine/core";
import React from "react";
import useSWR from "swr";
import * as yup from "yup";
import { categoryApi, itemTypeApi } from "../../apis";
import { ICategory } from "../../interfaces/ICategory";
import { IItemType } from "../../interfaces/IItemType";
import HttpHandler from "../../utils/http-handler";
import { Message } from "../../utils/message";
import { Form } from "../form";
import { CheckboxField } from "../form/checkbox-field";
import { SelectField } from "../form/select-field";
import { TextField } from "../form/text-field";
import { TextareaField } from "../form/textarea-field";
import { FormLayout } from "../layout";

const schema = yup.object({
  itemTypeId: yup.string().required("Заавал бөглөнө!").nullable(),
  name: yup.string().max(255, "Хэт урт байна!").required("Заавал бөглөнө!").nullable(),
  description: yup.string().max(255, "Хэт урт байна!").required("Заавал бөглөнө!").nullable(),
});

type IFormData = {
  itemTypeId: string;
  name: string;
  description: string;
  classificationId: string;
  isPublic: boolean;
  type: string;
  check: boolean;
};

export function SubClassificationForm({ onCancel, action, reload }: { onCancel?: () => void; action: any; reload: () => void }) {
  const [itemType, setItemType] = React.useState<string>("");
  const [loading, setLoading] = React.useState(false);
  const [data] = React.useState<IFormData>({
    itemTypeId: "",
    classificationId: "",
    name: "",
    type: "SUB_CLASSIFICATION",
    isPublic: false,
    description: "",
    check: false,
    ...(action && action[0] === "update"
      ? {
          ...action[1],
          itemTypeId: action[1]?.itemType?.id,
          classificationId: action[1]?.classification?.name,
          check: true,
        }
      : {}),
  });

  const onSubmit = async (value: IFormData) => {
    const dataCreate = {
      name: value.name,
      description: value.description,
      type: value.type,
      isPublic: value.isPublic,
      itemTypeId: value.itemTypeId,
      parentId: value.classificationId,
    };

    const dataUpdate = {
      name: value.name,
      description: value.description,
      isPublic: value.isPublic,
    };

    setLoading(true);
    try {
      if (action && action[0] === "update") {
        await categoryApi.update(action[1].id, {
          ...dataUpdate,
        });
      } else {
        await categoryApi.create(dataCreate);
      }

      Message.success("Таны хүсэлт амжилттай!");
      onCancel && onCancel();
      reload();
    } catch (err) {
      Message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  const { data: itemData } = useSWR(
    `/erp/back_office/item_reference/item_type/select/sub_classfication`,
    async () => {
      let res = await itemTypeApi.select({ query: "", limit: "" });
      return res;
    },
    {},
  );

  const { data: classificationData } = useSWR(
    `/erp/back_office/item_reference/category/select/sub_classfication/${itemType}`,
    async () => {
      if (!itemType) {
        return [];
      }
      let res = await categoryApi.select({
        query: "",
        itemTypeId: itemType,
        type: "",
      });
      return res;
    },
    {},
  );

  return (
    <Form validationSchema={schema} onSubmit={onSubmit} initialValues={data}>
      {({ values, setFieldValue }) => {
        return (
          <FormLayout
            title="Дэд ангилал"
            subTitle={
              action && action[0] !== "update"
                ? "Бараа бүтээгдэхүүн, ажил үйлчилгээний дэд ангилал нэмэх"
                : "Бараа бүтээгдэхүүн, ажил үйлчилгээний дэд ангилал засварлах"
            }
            my={0}
            extra={[<CloseButton key="cancel" onClick={() => onCancel && onCancel()} />]}>
            <LoadingOverlay visible={loading} />
            <Flex gap={15} direction="column">
              <Divider />
              <SelectField
                name="itemTypeId"
                label="Нэр төрөл"
                placeholder="сонгох"
                options={(itemData || []).map((c: IItemType) => ({ label: c.name, value: c.id }))}
                onChange={(e) => {
                  setFieldValue("classificationId", undefined);
                  setItemType(e as string);
                }}
                disabled={action && action[0] === "update"}
                required
              />
              {action && action[0] === "update" ? (
                <TextField name="classificationId" label="Ангилал" placeholder="нэр" required disabled />
              ) : (
                <SelectField
                  name="classificationId"
                  label="Ангилал"
                  placeholder="сонгох"
                  options={(classificationData || []).map((c: ICategory) => ({ label: c.name, value: c.id }))}
                  disabled={!values.itemTypeId}
                  required
                />
              )}
              <TextField name="name" label="Нэр" placeholder="Нэр" />
              <CheckboxField name="isPublic" label="Нээлттэй" />
              <TextareaField name="description" label="Тайлбар" placeholder="Тайлбар" />
              <Divider mb={10} />
            </Flex>

            <Flex justify="space-between">
              <Button key={1} variant="default" onClick={() => onCancel && onCancel()}>
                Болих
              </Button>
              <Button key={2} type="submit">
                Хадгалах
              </Button>
            </Flex>
          </FormLayout>
        );
      }}
    </Form>
  );
}
